<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>远程预付费</el-breadcrumb-item>
      <el-breadcrumb-item>银联支付信息管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 数据列表 -->

    <el-tabs type="border-card" @tab-click="tabChange">
      <el-tab-pane label="支付规则管理">
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>
          <el-form-item label="搜索：">
            <el-input placeholder="请输入搜索内容" @keyup.enter.native="search" v-model="formInline.name" size="small"></el-input>
          </el-form-item>
          <el-form-item v-if="user.username == 'admin'" label="所属部门">
            <el-select v-model="formInline.departmentId" placeholder="请选择" size="small">
              <el-option v-for="item in treeDate" :key="item.id" :label="item.departmentName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="getData()">搜索</el-button>
            <el-button size="mini" type="primary" @click="handelAdd">添加</el-button>
          </el-form-item>
        </el-form>

        <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="dataList" highlight-current-row
             border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>
             <el-table-column align="center" type="index" width="60">
             </el-table-column>
             <el-table-column prop="departmentName" label="部门名称" sortable>
             </el-table-column>
             <el-table-column prop="ruleName" label="名称" sortable>
             </el-table-column>

             <el-table-column label="状态">
               <template slot-scope="scope">
                 <el-tag size="mini" v-if="scope.row.status == 1">待审核</el-tag>
                 <el-tag type="success" size="mini" v-if="scope.row.status == 2">已通过</el-tag>
                 <el-tag type="danger" size="mini" v-if="scope.row.status == 3">审核不通过</el-tag>
               </template>
             </el-table-column>
             <!--  <el-table-column prop="createBy" label="创建人" >
             </el-table-column>
        -->
             <el-table-column prop="createDate" label="创建时间" sortable>
             </el-table-column>
             <el-table-column prop="rate" label="费率" sortable>
             </el-table-column>

             <el-table-column align="center" label="操作" width="340">
               <template slot-scope="scope">
                 <el-button type="primary" size="mini" @click="handelDetail(scope.row)">编辑</el-button>
                 <el-button type="danger" size="mini" @click="handelDel(scope.row)">删除</el-button>
                 <el-button type="warning" size="mini" @click="handelSp(scope.row)">审核</el-button>
                 <el-button type="warning" size="mini" @click="handelFz(scope.row)">支付信息</el-button>

               </template>
             </el-table-column>
           </el-table>
      </el-tab-pane>
      <el-tab-pane label="分账信息列表"  v-if="user.username == 'admin'" >
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search" ref='searchbox' @submit.native.prevent>

          <el-form-item  label="搜索：">
            <el-select  clearable v-model="accountFrom.status" placeholder="请选择状态" size="small" @change="getAccountList">
              <el-option label="分账受理成功" value="00" ></el-option>
              <el-option label="分账处理中" value="01" ></el-option>
              <el-option label="分账处理完成" value="02" ></el-option>
              <el-option label="分账处理失败" value="03" ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="getAccountList">搜索</el-button>

          </el-form-item>
        </el-form>

        <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="accountList" highlight-current-row
             v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>
             <el-table-column align="center" type="index" width="60">
             </el-table-column>

             <el-table-column prop="acsMerNo" label="商户号" width="180" sortable>
             </el-table-column>
             <el-table-column prop="merOrderNo" label="订单号" sortable>
             </el-table-column>
             <el-table-column prop="psMerOrderNo" label="商户分账单号" sortable>
             </el-table-column>
             <el-table-column prop="psOrderDate" label="分账日期"  width="140" sortable>
             </el-table-column>
             <el-table-column prop="psOrderReqId" label="分账订单请求标识" sortable>
             </el-table-column>
             <el-table-column prop="resultRemark" label="分账备注">
             </el-table-column>
             <el-table-column label="状态" width="140" sortable>
               <template slot-scope="scope">
                 <el-tag size="mini" v-if="scope.row.status == '00'">分账受理成功</el-tag>
                 <el-tag type="warning" size="mini" v-if="scope.row.status == '01'">分账处理中</el-tag>
                 <el-tag type="danger" size="mini" v-if="scope.row.status == '02'">分账处理完成</el-tag>
                 <el-tag type="danger" size="mini" v-if="scope.row.status == '03'">分账处理失败</el-tag>
               </template>
             </el-table-column>



             <el-table-column align="center" label="操作" width="120">
               <template slot-scope="scope">
                 <el-button type="primary" size="mini" @click="handelAccDetail(scope.row)">查看详情</el-button>


               </template>
             </el-table-column>
        </el-table>

        <Pagination v-bind:child-msg="accountFrom" @callFather="zfcallFather" v-if="showPage"></Pagination>

      </el-tab-pane>
      <el-tab-pane label="划付清单" v-if="user.username == 'admin'"  >
        <!-- 搜索筛选 -->
        <el-form :inline="true"  class="user-search" ref='searchbox' >

          <el-form-item  label="搜索：">
            <el-input size="small" v-model="hForm.merOrderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button size="mini" type="primary" @click="getRowPayQueryList">搜索</el-button>

          </el-form-item>
        </el-form>

        <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="hList" highlight-current-row
             v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>
             <el-table-column align="center" type="index" width="60">
             </el-table-column>

             <el-table-column prop="acsMerNo" label="商户号" width="180" sortable>
             </el-table-column>
             <el-table-column prop="merOrderNo" label="订单号" sortable>
             </el-table-column>
             <el-table-column prop="psMerOrderNo" label="商户分账单号" sortable>
             </el-table-column>




             <el-table-column align="center" label="操作" width="120">
               <template slot-scope="scope">
                 <el-button type="primary" size="mini" @click="handelPayRowDetail(scope.row)">查看详情</el-button>
               </template>
             </el-table-column>
        </el-table>

        <Pagination v-bind:child-msg="hForm" @callFather="callFatherHf" v-if="showPage"></Pagination>

      </el-tab-pane>

    </el-tabs>





    <el-dialog :title="title" :visible.sync="FormVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editForm">
        <el-form-item v-if="user.username == 'admin'" label="部门：" prop="departmentId">
          <el-select v-model="editForm.departmentId" placeholder="请选择" size="small" @change="changeDept">
            <el-option v-for="item in treeDate" :key="item.id" :label="item.departmentName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规则名称：" prop="ruleName">
          <el-input size="small" v-model="editForm.ruleName" placeholder="请输入规则名称"></el-input>
        </el-form-item>

        <!-- <el-form-item label="创建人：">
           <el-input  size="small" v-model="editForm.ruleName" placeholder="请输入创建人" ></el-input>
        </el-form-item> -->
        <el-form-item label="费率：" prop="rate">
          <el-input size="small" v-model="editForm.rate" placeholder="请输入费率"></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态：">
           <el-radio-group v-model="editForm.status">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="0">禁用</el-radio>
            </el-radio-group>
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='FormVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="handeRuleSave('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog title="支付信息列表" :visible.sync="szListVisible" width="70%" :close-on-click-modal="false">

      <div style="margin-bottom: 10px;">
        <el-button type="primary" size="small" @click="handelAddFz">添加</el-button>
        <el-button tsize="small" size="small" @click="getSplitAccount">刷新</el-button>
      </div>
      <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="fzDataList" highlight-current-row
           border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>
           <el-table-column align="center" type="index" width="60">
           </el-table-column>
           <el-table-column prop="receiverName" label="支付接收方名称">
           </el-table-column>
           <el-table-column prop="bankAccountNo" label="银行账号">
           </el-table-column>
           <el-table-column prop="psNo" label="支付接收方编码" >
           </el-table-column>
           <el-table-column prop="createDate" label="创建时间" >
           </el-table-column>
           <el-table-column label="进件状态" width="180" >
            <template slot-scope="scope">

              <el-tag size="mini"   v-if="scope.row.status == 1 ">申请已接收</el-tag>
              <el-tag size="mini" type="info" v-if="scope.row.status == 2 ">待短信确认</el-tag>
              <el-tag size="mini" type="danger"  v-if="scope.row.status == 3 ">待审核</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.status == 4 ">进件完成</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.status == 5 ">进件失败</el-tag>
            </template>
            </el-table-column>


           <el-table-column label="申请状态" width="180" >
            <template slot-scope="scope">
              <el-tag size="mini" type="info" v-if="scope.row.changeStatus == 0 ">短信待确认</el-tag>
              <el-tag size="mini" type="warning"  v-if="scope.row.changeStatus == 1 ">待审核</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.changeStatus == 2 ">审核成功</el-tag>
              <el-tag size="mini" type="danger"  v-if="scope.row.changeStatus == 8 ">审核失败</el-tag>
              <el-tag size="mini" type="danger" v-if="scope.row.changeStatus == 9 ">申请失败</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.changeStatus == 11 ">未变更</el-tag>
            </template>
            </el-table-column>
          </el-table-column>
           <el-table-column align="center" label="操作"  width="260">
             <template slot-scope="scope">
               <el-button type="primary" size="mini" :disabled="scope.row.changeStatus == 1"  @click="handelFzDetail(scope.row)">编辑</el-button>
               <el-button type="danger" size="mini" @click="handelfzDel(scope.row)">删除</el-button>
               <el-button type="danger" size="mini" :disabled="scope.row.changeStatus == 1" @click="handelMsg(scope.row)">短信验证</el-button>

             </template>
           </el-table-column>
         </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='szListVisible = false'>关闭</el-button>

      </div>
    </el-dialog>


    <el-dialog title="支付信息" :visible.sync="fzVisible" width="60%" :close-on-click-modal="false">
      <!-- <span style="color: #409EFF; font-size: 12px;">带红色'*'为必填项</span> -->
      <el-form :model="fzEditForm" label-width="136px" ref="fzEditForm" :rules="fzRule">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="分账接收方名称：" prop="receiverName">
              <el-input :disabled="isDatail" size="small" v-model="fzEditForm.receiverName" placeholder="请输入分账接收方名称"></el-input>
            </el-form-item>
            <el-form-item label="分账证明材料：" prop="psDocId">
              <el-upload ref="fzUpload1" :file-list="utype1" :disabled="isDatail"   action="#" :http-request="importfile" :data="{type:1}"  :on-remove="(file, fileList) => {handleRemove(file, fileList)}">
                <el-button :disabled="isDatail"  size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="接收方类型：">
              <el-select :disabled="isDatail" v-model="fzEditForm.receiverType" placeholder="请选择" size="small" @change="receiverTypeChange">
                <el-option label="企业" :value="1"></el-option>
                <el-option label="个体户" :value="0"></el-option>
                <el-option label="自然人" :value="2"></el-option>
              </el-select>
            </el-form-item>
           <!-- <el-form-item label="接收方证件类型：">
              <el-select v-model="fzEditForm.receiverCertType" placeholder="请选择" size="small">
                <el-option label="统一社会信用代码" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item  label="接收方证件号码：" prop="receiverCertNo">

              <el-input :disabled="isDatail" size="small" v-model="fzEditForm.receiverCertNo" placeholder="请输入统一社会信用代码"></el-input>
              <div class="e-ps warning">
                <p>1.接收方类型为企业、个体户的时候填写统一社会信用代码</p>
                <p>2.接收方类型为自然人的时候填写身份证号码</p>
              </div>
            </el-form-item>

            <el-form-item label="证件有效日期：" prop="zfDate" v-if="fzEditForm.receiverType == '2'">
              <el-date-picker @change="getfzDate"   size="small" value-format="yyyy-MM-dd" v-model="fzIdDate" type="daterange"
                range-separator="至" start-placeholder="证件开始日期" end-placeholder="证件结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="接收方证件文件：" prop="receiverCertFileId" v-if="fzEditForm.receiverType != 2">
              <el-upload ref="fzUpload2" :file-list="utype2" :disabled="isDatail" action="#" :http-request="importfile" :data="{type:2}" :limit="1" :on-remove="() => {removeFile(2)}">
                <el-button :disabled="isDatail" size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="门头照：" prop="storePicFileId" v-if="fzEditForm.receiverType != 2">
              <el-upload ref="fzUpload3" :file-list="utype3" :disabled="isDatail" action="#" :http-request="importfile" :data="{type:3}" :limit="1" :on-remove="() => {removeFile(3)}">
                <el-button :disabled="isDatail" size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>

            <el-form-item label="开户许可证照片：" prop="bankAccountFileId" v-if="fzEditForm.receiverType != 2" >
              <el-upload ref="fzUpload4" :file-list="utype4" action="#" :http-request="importfile" :data="{type:4}" :limit="1" :on-remove="() => {removeFile(4)}" >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>


            <el-form-item label="分账说明：" prop="psRemark">
              <el-select :disabled="isDatail" v-model="fzEditForm.psRemark" placeholder="请选择" size="small">
                <el-option label="货款" :value="0"></el-option>
                <el-option label="平台抽佣" :value="1"></el-option>
                <el-option label="收益分配" :value="2"></el-option>
                <el-option label="结算款" :value="3"></el-option>
                <el-option label="劳动报酬" :value="4"></el-option>
                <el-option label="售后服务款" :value="5"></el-option>
                <el-option label="其他" :value="9"></el-option>

              </el-select>
            </el-form-item>
            <el-form-item label="分成：" prop="divide">

              <el-input style="width: 215px;" v-model="fzEditForm.divide" size="small" placeholder="请输入分成"></el-input>&nbsp;%
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="银行账户类型：">

              <el-select v-model="fzEditForm.bankAccountType" :disabled="receiverTypeCanNotChange" placeholder="请选择" size="small">

                <el-option label="对公" :value="1"></el-option>
                <el-option label="对私" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="银行开户地址：" prop="bankAddress">

              <el-cascader size="small" :options="address" v-model="bankAddress" @change="handelAddress"></el-cascader>
            </el-form-item>
            <el-form-item label="开户网点名称：" prop="bankName">

              <el-input v-model="fzEditForm.bankName" size="small" placeholder="请输入开户网点名称"></el-input>
              <div class="e-ps tip">
                <p>例如：中国工商银行广州天河支行</p>
              </div>


            </el-form-item>

             <el-form-item label="银行预留电话：" prop="bankPhone" v-if="fzEditForm.bankAccountType != 1">

              <el-input v-model="fzEditForm.bankPhone" size="small" placeholder="请输入银行预留电话"></el-input>
            </el-form-item>
            <el-form-item label="银行账号：" prop="bankAccountNo">

              <el-input v-model="fzEditForm.bankAccountNo" size="small" placeholder="请输入银行账号"></el-input>
            </el-form-item>
            <el-form-item label="银行账户名称：" prop="bankAccountName">

              <el-input v-model="fzEditForm.bankAccountName" size="small" placeholder="例如：广州银联网络支付有限公司"></el-input>
              <div class="e-ps warning">
                <p>个体户为对私账户时，银行账户名称必须为法人名称</p>

              </div>
            </el-form-item>
            <el-form-item label="银行代码：">
              <el-input v-model="fzEditForm.bankCode" size="small" placeholder="请输入银行代码"></el-input>
            </el-form-item>
            <el-form-item label="电子联行号：">
              <el-input v-model="fzEditForm.bankNetCode" size="small" placeholder="请输入电子联行号"></el-input>
            </el-form-item>
            <el-form-item label="开户行别：">
              <el-input v-model="fzEditForm.acctBank" size="small" placeholder="请输入开户行别"></el-input>
            </el-form-item>


            <el-form-item  label="干系人列表：" v-if="fzEditForm.receiverType != 2 ">
              <div v-if="manList.length">
                <span  style="display: block; " v-for="(item,idx) in manList">
                  <el-tag style="cursor: pointer;"  @click="detailMan(item,idx)" size="small">{{item.manName}}</el-tag>
                  <i @click="dellMan(item,idx)"  style="color: #F56C6C; position: relative;top: -8px;left: -5px; font-size: 18px;"  class="el-icon-circle-close"></i>
                </span>
              </div>
              <el-button size="small" type="primary"  @click="handelGx">点击添加干系人信息</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='fzVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="fzSetloading" class="title" @click="handelSaveRule">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="gTitle+'干系人信息'" :visible.sync="gxVisible" width="50%" :close-on-click-modal="false">
      <el-form :model="tempMan" label-width="150px" :rules="manRules" ref="tempMan">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="类型：" prop="manType">
              <el-select v-model="tempMan.manType" placeholder="请选择" size="small">
                <el-option label="股东" value="1"></el-option>
                <el-option label="受益人" value="2"></el-option>
                <el-option label="控制人" value="3"></el-option>
                <el-option label="法人" value="4"></el-option>
                <el-option label="财务联系人" value="5"></el-option>
                <el-option label="本人" value="6"></el-option>
                <el-option label="授权办理人" value="7"></el-option>
                <el-option label="技术联系人" value="8"></el-option>
                <el-option label="业务联系人" value="9"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="干系人姓名：" prop="manName">
              <el-input size="small" v-model="tempMan.manName" placeholder="请输入干系人姓名"></el-input>
            </el-form-item>

            <el-form-item label="证件类型：">
              <el-select v-model="tempMan.certType" placeholder="请选择" size="small">
                <el-option   label="身份证" :value="31"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码：" prop="certNo">
              <el-input onkeyup="this.value=this.value.replace(/[^\X0-9]/g, '')" size="small" v-model="tempMan.certNo" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="证件有效日期：" prop="date">
              <el-date-picker  @change="getGXdate" size="small" value-format="yyyy-MM-dd" v-model="idDate" type="daterange"
                range-separator="至" start-placeholder="证件开始日期" end-placeholder="证件结束日期">
              </el-date-picker>
            </el-form-item>

          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证人像面照片：" prop="faceImageFileId">
              <el-upload ref="upid1"  :file-list="gtype1"  :limit="1" action="#"   :http-request="importGXfile" :data="{type:1}" :on-remove="() => {removeGxFile(1)}">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证国徽面照片：" prop="nationalImageFileId">
              <el-upload  ref="upid2" :file-list="gtype2" :limit="1" action="#" :http-request="importGXfile" :data="{type:2}" :on-remove="() => {removeGxFile(2)}">
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="联系手机：" prop="ctctCell">
              <el-input size="small" v-model="tempMan.ctctCell" placeholder="请输入联系手机"></el-input>
            </el-form-item>
            <el-form-item label="干系人地址：">
              <el-input size="small" v-model="tempMan.ctctAddr" placeholder="请输入地址"></el-input>
            </el-form-item>
            <el-form-item label="干系人邮箱：">
              <el-input size="small" v-model="tempMan.ctctEmail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>


      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='gxVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveMan">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审批" :visible.sync="spVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="spForm" ref="spForm" :rules="spRule">

        <el-form-item label="状态：" prop="status">
          <el-radio-group v-model="spForm.status">
            <el-radio :label="2">通过</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='spVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="changeStatus">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="短信确认" :visible.sync="msgVisible" width="30%" :close-on-click-modal="false">
      <el-form :model="msgForm" ref="msgForm" :rules="msgRule" label-width="100px">

        <el-form-item label="短信类型"  >

          <el-select v-model="msgForm.busType" size="small">
            <el-option :value="0" label="进件短信重发"></el-option>
            <el-option :value="1" label="分账接收方变更短信重发"></el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="验证码：" prop="verifyCode" >

          <el-input size="small" placeholder="请输入手机验证码" v-model="msgForm.verifyCode" ></el-input>
          <el-button size="small" :loading="loadSend" :disabled="notSend"  type="warning" @click="reSend">获取验证码{{dNum}}</el-button>

        </el-form-item>


      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='msgVisible = false'>取消</el-button>
        <el-button size="small" type="primary" :loading="setLoading" class="title" @click="saveMgs">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="分账详情" :visible.sync="accountVisibel" width="50%" :close-on-click-modal="false">
      <el-descriptions title="分账信息详情">

          <el-descriptions-item label="交易时间">{{accountItem.tranTime}}</el-descriptions-item>

          <el-descriptions-item label="订单金额">{{accountItem.orderAmount}}<el-tag style="margin-left:4px"  size="mini">分</el-tag></el-descriptions-item>
          <el-descriptions-item label="交易分账总金额">{{accountItem.psTotalAmount}}<el-tag style="margin-left:4px"  size="mini">分</el-tag></el-descriptions-item>
          <el-descriptions-item label="交易可分账余额">{{accountItem.psRestAmount}}<el-tag style="margin-left:4px"  size="mini">分</el-tag></el-descriptions-item>
          <el-descriptions-item label="商户手续费">{{accountItem.merFee}}<el-tag style="margin-left:4px"  size="mini">分</el-tag></el-descriptions-item>
          <el-descriptions-item label="结算日期">{{accountItem.acDate}}</el-descriptions-item>

          <el-descriptions-item label="备注">{{accountItem.remark}} </el-descriptions-item>
          <el-descriptions-item label="商户订单号">{{accountItem.merOrderNo}}</el-descriptions-item>
      </el-descriptions>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='accountVisibel = false'>关闭</el-button>

      </div>
    </el-dialog>


    <el-dialog title="划付详情" :visible.sync="payRowVisible" width="80%" :close-on-click-modal="false">


      <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="payRowList" highlight-current-row
            border element-loading-text="拼命加载中" style="width: 100%;" ref="tablelist" stripe>
           <el-table-column align="center" type="index" width="60">
           </el-table-column>
           <el-table-column prop="type" label="商户" width='100' >
             <template slot-scope="scope">
               <el-tag size="mini"  v-if="scope.row.type == 'C' ">个人</el-tag>
               <el-tag size="mini" type="success"  v-if="scope.row.type == 'B' ">企业</el-tag>
               <el-tag size="mini" type="success"  v-if="scope.row.type == 'MER' ">商户</el-tag>
             </template>
           </el-table-column>
           <el-table-column prop="psMerOrderNo" label="商户分账单号">
           </el-table-column>
           <el-table-column prop="psNo" label="分账接收方编码" >
           </el-table-column>
           <el-table-column prop="psOrderReqId" label="分账订单请求标识" >
           </el-table-column>
           <el-table-column prop="paySn" label="划付流水号" >
           </el-table-column>
           <el-table-column prop="payAmount" width='100' label="划付金额" >
           </el-table-column>
           <el-table-column prop="psAmount" width="100" label="分账金额" >
           </el-table-column>
           <el-table-column prop="payFinishTime" label="划付完成时间" >
           </el-table-column>

           <el-table-column  label="划付结果" width="120" >
            <template slot-scope="scope">
              <el-tag size="mini" type="info" v-if="scope.row.payResult == '00' ">待划付</el-tag>
              <el-tag size="mini" type="warning"  v-if="scope.row.payResult == '01' ">划付处理中</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.payResult == '02' ">划付成功</el-tag>
              <el-tag size="mini" type="danger"  v-if="scope.row.payResult == '03' ">划付失败</el-tag>
              <el-tag size="mini" type="danger" v-if="scope.row.payResult == '05' ">异常退汇</el-tag>
              <el-tag size="mini" type="success" v-if="scope.row.payResult == '06' ">划付重提</el-tag>
            </template>
          </el-table-column>


         </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='payRowVisible = false'>关闭</el-button>

      </div>
    </el-dialog>





  </div>
</template>

<script>
  import {
    addRule,
    get_split_rule_page,
    editRule,
    delRule,
    uploadFile,
    approve_rule,
    fileOnload,
    add_split_rule_account,
    get_split_account,
    del_split_account_detail,
    get_split_account_detail,
    eidt_split_rule_account,
    messageConfirmation,
    messageResend,
    findSubAccountList,
    findClearingTheQuery,
    findRowPayQueryList,
    findRowForDetails
  } from '../../api/bankMG.js'
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG'
  import options from '../../assets/data/country-data.js'
  import {
    timestampToTime,
    isIdentityId
  } from '@/utils/util'
  import PremsButton from "@/views/permission/PreButtom";
  import Pagination from '../../components/Pagination'

  import axios from 'axios';
  export default {
    data() {

      var validateSp = (rule, value, callback) => {



        if (this.spForm.status === 1) {
          callback(new Error('请选择审批状态'));
        } else {

          callback();
        }
      };


      var isIdCard  = (rule, value, callback) => {
        var errorMsg = isIdentityId(value);
        // var errorMsg = 'ss'
        console.log(errorMsg)
        if (errorMsg != "") {
          callback(new Error(errorMsg));
        }else{
          callback();
        }
      };
      var id1 = (rule, value, callback) => { // 图片验证
        if (this.tempMan.faceImageFileId == '') {
          callback(new Error('请上传身份证人像面照片'));
        } else {
          callback();
        }
      };
      var id2 = (rule, value, callback) => { // 图片验证
        if (this.tempMan.nationalImageFileId == '') {
          callback(new Error('请上传身份证国徽面照片'));
        } else {
          callback();
        }
      };

      var vdate = (rule, value, callback) => {
        if (this.idDate == '') {
          callback(new Error('请选择证件有效时间'));
        } else {
          callback();
        }
      };
      var vbankAddress = (rule, value, callback) => {
        if (this.fzEditForm.bankCity == '' || this.fzEditForm.bankProvince == '') {
          callback(new Error('请选择开户行地址'));
        } else {
          callback();
        }
      };
      var vpsDocId = (rule, value, callback) => {
        if (this.fzEditForm.psDocId == '') {
          callback(new Error('请上传分账证明材料'));
        } else {
          callback();
        }
      };
      var vreceiverCertFileId = (rule, value, callback) => {
        if (this.fzEditForm.receiverCertFileId == '') {
          callback(new Error('请上传接收方证件文件'));
        } else {
          callback();
        }
      };
      var vstorePicFileId = (rule, value, callback) => {
        if (this.fzEditForm.storePicFileId == '') {
          callback(new Error('请上传门头照'));
        } else {
          callback();
        }
      };
      var vbankAccountFileId = (rule, value, callback) => {
        if (this.fzEditForm.bankAccountFileId == '') {
          callback(new Error('请上传开户许可证照片'));
        } else {
          callback();
        }
      };
      var vzfDate = (rule, value, callback) => {
        if (this.fzIdDate == '') {
          callback(new Error('证件有效日期不能为空'));
        } else {
          callback();
        }
      };


      return {
        fzLoading:false,
        payRowVisible:false,
        dNum:'',
        notSend:false,
        isDatail:false,
        fzDataList:[],
        utype1:[],
        utype2:[],
        utype3:[],
        utype4:[],

        gtype1:[],
        gtype2:[],
        gTitle:"添加",
        fzIdDate:"",
        idDate: "",
        loading: false,
        spVisible: false,
        title: '添加',
        showPage: true,
        loadStatus: false,
        FormVisible: false,
        gxVisible: false,
        fzVisible: false,
        currid: '',
        selectValue: [],
        depId: "",
        msgVisible:false,
        editForm: {
          ruleName: "",
          departmentId: "",
          rate: ""
        },
        payRowList:[],

        hForm:{
          currentPage: 1,
          pageSize: 10,
          total:0,
          merOrderNo:''
        },
        msgForm:{
          acsMerNo:"",
          applyNo:"",
          busType:0,
          verifyCode:"",
        },
        accountItem:{},
        accountList:[],
        treeDate: [],
        hList:[],
        formInline: {
          currentPage: 1,
          pageSize: 10,
          departmentId: "",
        },
        accountFrom:{
          currentPage: 1,
          pageSize: 10,
          total:0,
          status:''
        },
        fzSetloading:false,
        gxVisible: false,
        bankAddress: [],
        accoutItem:{},

        fzEditForm: {
          receiverName:"",
          psDocId:"",
          receiverCertFileId:"",
          storePicFileId:"",
          bankAccountFileId:"",
          certEffectDate:"",
          certExpireDate:"",
          bankCounty: "", //行区/县
          bankCity: '', //开户行城市,
          bankProvince: "", //开户行省份
          psReceiverName: "",
          receiverType: "1",
          receiverCertType: 11,
          receiverCertNo: "",
          bankAccountType: "1",
          bankName: "",
          bankAccountNo: "",
          bankAccountName: "",
          bankCode: "",
          bankNetCode: "",
          acctBank: "",
          ruleAccountFileList: [],
          custManList: [],
          divide: '',
          bankPhone: "",
          certEffectDate: "",
          certExpireDate: "",
          ruleId: "",
        },
        manList: [],
        tempMan: {
          "certEffectDate": "",
          "certExpireDate": "",
          "certNo": "",
          "certType": 31,
          "ctctAddr": "",
          "ctctCell": "",
          "ctctEmail": "",
          "manFileList": [],
          "manName": "",
          "manType": '1',
          faceImageFileId: '',
          nationalImageFileId: ""
        },
        spForm: {
          id: '',
          status: "",
        },
        accountVisibel:false,
        szListVisible:false,
        receiverTypeCanNotChange:false,
        setLoading: false,
        user: {},
        loadLoadin: false,
        dateData: [],
        dataList: [],
        address: [],
        loadSend:false,
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        timer:null,
        curGxIdx:0,
        spRule: {
          status: [{
            validator: validateSp,
            trigger: 'change'
          }]
        },
        msgRule:{
          verifyCode:[{required:true,message:"请输入验证码",trigger:'blur'}]
        },

        fzRule: {
          receiverName: [{
            required: true,
            message: "请输入分账接收方名称",
            trigger: 'blur'
          }],
          bankPhone: [{
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            required: true,
            message: "银行预留手机号码有误且不能为空",
            trigger: 'blur'
          }],
          bankAddress: [{
            required: true,
            validator: vbankAddress,
            trigger: 'chnage'
          }],
          bankName: [{
            required: true,
            message: "请输入开户网点名称",
            trigger: 'blur'
          }],
          bankAccountNo: [{
            required: true,
            message: "请输入银行账号",
            trigger: 'blur'
          }],
          bankAccountName: [{
            required: true,
            message: "请输入银行账户名称",
            trigger: 'blur'
          }],
          receiverCertNo: [{
            required: true,
            message: "请输入接收方证件号码",
            trigger: 'blur'
          }],
          psRemark: [{
            required: true,
            message: "请选择分账说明",
            trigger: 'change'
          }],
          divide: [{
            required: true,
            message: "请输入分成",
            trigger: 'change'
          }],


          psDocId: [{
            required: true,
            validator: vpsDocId,
            trigger: "blur"
          }],
          receiverCertFileId: [{
            required: true,
            validator: vreceiverCertFileId,
            trigger: "blur"
          }],
          storePicFileId: [{
            required: true,
            validator: vstorePicFileId,
            trigger: "blur"
          }],
          bankAccountFileId: [{
            required: true,
            validator: vbankAccountFileId,
            trigger: "blur"
          }],
          zfDate:[{
            required: true,
            validator: vzfDate,
            trigger: "blur"
          }]

        },

        manRules: {
          manName: [{
            required: true,
            message: "请输入干系人姓名",
            trigger: 'blur'
          }],
          certNo: [{
              required: true,
              validator: isIdCard,
              trigger: "blur" ,
          }],
          certEffectDate: [{
            required: true,
            message: "请选择证件有效时间",
            trigger: 'change'
          }],
          ctctCell: [{
            pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
            required: true,
            message: '请输入正确的手机号且不能为空',
            trigger: 'blur'
          }],
          faceImageFileId: [{
            required: true,
            validator: id1,
            trigger: 'change'
          }],
          nationalImageFileId: [{
            required: true,
            validator: id2,
            trigger: 'change'
          }],
          date: [{
            required: true,
            validator: vdate,
            trigger: 'change'
          }]
        },

        rules: {
          ruleName: [{
            required: true,
            message: '请输入规则名称',
            trigger: 'blur'
          }],
          departmentId: [{
            required: true,
            message: '请输入规则名称',
            trigger: 'change'
          }],
          rate: [{
            required: true,
            message: '请输入费率',
            trigger: 'blur'
          }],
          	ctctCell: [{
          	  pattern: /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/,
          	  required: true,
          	  message: '请输入正确的手机号',
          	  trigger: 'blur'

          	}],
          // 	roomNum:[{validator:validatePass,trigger:'change' }]

        },
      }
    },
    // 注册组件
    components: {
      Pagination,
      PremsButton
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem('userdata'))

      this.getData()
      this.getJzData();
      this.getAccountList();
      this.getRowPayQueryList();
      this.address = options

      this.address.forEach(item => {
        item.children.forEach(sitem => {
          sitem.children.unshift( {"value": "", "label": "无"} )
        })
      })

    },
    methods: {

      tabChange(e){

      },

      handelPayRowDetail(row){
        this.payRowVisible = true
        findRowForDetails({rowPayQueryId:row.id}).then(res => {
          if(res.status == 1){
            this.payRowList = res.data
          }
        })
      },

      callFatherHf(parm){
        this.hForm.currentPage = parm.currentPage
        this.hForm.pageSize = parm.pageSize
        this.getRowPayQueryList()
      },

      getRowPayQueryList(){
        findRowPayQueryList(this.hForm).then(res => {
          if(res.status == 1){
            this.hList = res.data.content
            this.hForm.total = res.data.totalElements
          }
        })
      },

      handelAccDetail(row){
        this.accountVisibel = true
        findClearingTheQuery(row).then(res => {
          if(res.status == 1 ){
            this.accountItem = res.data
          }else{
            this.$message.error(res.msg)
          }
        })
      },

      getAccountList(){
        findSubAccountList(this.accountFrom).then(res => {
          if(res.status == 1){
            this.accountList = res.data.content || []
            this.accountFrom.total = res.data.totalElements
          }else{
              this.accountList = []
          }
        })
      },

      handelMsg(row){
        this.msgVisible = true
        this.msgForm.acsMerNo = row.acsMerNo
        this.msgForm.applyNo = row.applyNo
        this.msgForm.busType = this.isDatail ? 1:0
        this.msgForm.verifyCode = ''
      },
      saveMgs(){

        this.$refs.msgForm.validate(valida => {
          if(valida){
            messageConfirmation(this.msgForm).then(res => {
              if( res.status == 1){
                this.$message.success('操作成功！')
                this.msgVisible = false
              }else{
                this.$message.error(res.msg)
              }
            })
          }
        })
      },

      reSend(){
        let p = {
          busType:this.isDatail ? 1:0,
          acsMerNo:this.msgForm.acsMerNo,
          applyNo:this.msgForm.applyNo
        }
        this.loadSend = true
        messageResend(p).then(res => {
          this.loadSend = false
          if(res.status == 1){
            this.$message.success('短信发送成功，请注意查看手机短信')
            this.daojishi()
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      daojishi(){
        this.notSend = true
        this.dNum = 60
        this.timer = setInterval(() => {
          this.dNum--
          if(this.dNum == 0){
             clearInterval(this.timer);
             this.timer = null;
             this.dNum = ''
             this.notSend = false
          }
        },1000)
      },




      handelAddFz(){
        this.fzVisible = true
        this.isDatail = false
        this.utype1 = []
        this.utype2 = []
        this.utype3 = []
        this.utype4 = []
        this.bankAddress = []
        this.manList = []
        this.fzEditForm.receiverName = ''
        this.fzEditForm.psDocId = ""
        this.fzEditForm.receiverCertFileId = ""
        this.fzEditForm.storePicFileId = ""
        this.fzEditForm.bankAccountFileId = ""
        this.fzEditForm.certEffectDate = ""
        this.fzEditForm.certExpireDate = ""
        this.fzEditForm.bankCounty  = ""
        this.fzEditForm.bankCity  = ""
        this.fzEditForm.bankProvince = ""
        this.fzEditForm.psReceiverName = ""
        this.fzEditForm.receiverType = 1
        this.fzEditForm.receiverCertType  = 11
        this.fzEditForm.receiverCertNo = ""
        this.fzEditForm.bankAccountType  = 1
        this.fzEditForm.bankName = ""
        this.fzEditForm.bankAccountNo = ""
        this.fzEditForm.bankAccountName = ""
        this.fzEditForm.bankCode = ""
        this.fzEditForm.bankNetCode = ""
        this.fzEditForm.acctBank = ""
        this.fzEditForm.ruleAccountFileList = []
        this.fzEditForm.custManList = []
        this.fzEditForm.divide =  ''
        this.fzEditForm.bankPhone =  ""
        this.fzEditForm.certEffectDate =  ""
        this.fzEditForm.certExpireDate =  ""

        this.$nextTick(() => {
          this.$refs.fzEditForm.clearValidate()
          this.$refs.fzUpload1.clearFiles()
          this.$refs.fzUpload2.clearFiles()
          this.$refs.fzUpload3.clearFiles()
          this.$refs.fzUpload4.clearFiles()
        })
      },


      handelFzDetail(row){
        this.fzVisible = true
        this.isDatail = true
        this.utype1 = []
        this.utype2 = []
        this.utype3 = []
        this.utype4 = []

        get_split_account_detail(row.applyNo).then(res => {
          if(res.status == 1){
            this.fzEditForm = res.data
            this.fzEditForm.accountFileList.forEach(item => {
              let file = {
                name:item.fileName,
                url:item.filePath
              }
              if(item.useType == '1'){
                this.utype1.push(file)
              }else if(item.useType == '2'){
                this.utype2.push(file)
              }else if(item.useType == '3'){
                this.utype3.push(file)
              }else{
                this.utype4.push(file)
              }
              this.bankAddress = [ res.data.bankProvince,res.data.bankCity,res.data.bankCounty ]
              this.fzIdDate  = [ res.data.certEffectDate,res.data.certExpireDate]
            })
          }
        })
      },


      receiverTypeChange(){
        if(this.fzEditForm.receiverType != 1){
          this.fzEditForm.bankAccountType = 0
          this.receiverTypeCanNotChange = true
        }else{
          this.receiverTypeCanNotChange = false
        }


        if(this.fzEditForm.receiverType != 2){
          this.fzEditForm.receiverCertType = 11
        }else{
          this.fzEditForm.receiverCertType = 31
        }

      },

      getfzDate(val){
        this.fzEditForm.certEffectDate = val[0]
        this.fzEditForm.certExpireDate = val[1]
      },

      getGXdate(val) {

        this.tempMan.certEffectDate = val[0]
        this.tempMan.certExpireDate = val[1]
      },

      handleRemove(file, fileList){
        this.fzEditForm.ruleAccountFileList.splice( this.fzEditForm.ruleAccountFileList.findIndex(item => item.useType == 1 && item.originalName == file.name),1)
        if(this.fzEditForm.ruleAccountFileList.filter(item => item.useType == 1).length == 0){
           this.fzEditForm.psDocId = ""
        }

      },


      removeFile(useType){
        if(this.isDatail){
          this.fzEditForm.ruleAccountFileList = this.fzEditForm.accountFileList.filter(item => item.useType != useType)
        }else{
          this.fzEditForm.ruleAccountFileList = this.fzEditForm.ruleAccountFileList.filter(item => item.useType != useType)
        }

        if(useType == 2){
          this.fzEditForm.receiverCertFileId = ""
        }else if(useType == 3){
          this.fzEditForm.storePicFileId = ""
        }else if(useType == 4){
          this.fzEditForm.bankAccountFileId = ""
        }
      },

      //删除干系人身份证正反照片
      removeGxFile(type){

        console.log(this.tempMan)
        this.tempMan.manFileList = this.tempMan.manFileList.filter(item => item.useType != type)
        if(type == 1){
          this.tempMan.faceImageFileId == ''
        }else{
           this.tempMan.nationalImageFileId == ''
        }
      },


      //上传文件
      importfile(val) {
        let formData = new FormData();
        formData.append('file', val.file);
        console.log(val)
        fileOnload(formData).then(res => {
          if (res.status == 1) {
            this.fzEditForm.ruleAccountFileList.push({
              originalName:val.file.name,
              fileId: res.data.psFileId,
              fileName: res.data.imgName,
              filePath: res.data.imgPath,
              fileType: res.data.imgSuffix,
              useType: val.data.type
            })

            if(val.data.type == 1){
              this.fzEditForm.psDocId = res.data.imgPath
            }else if(val.data.type == 2){
              this.fzEditForm.receiverCertFileId = res.data.imgPath
            }else if(val.data.type == 3){
              this.fzEditForm.storePicFileId = res.data.imgPath
            }else if(val.data.type == 4){
              if(this.isDatail){
                this.fzEditForm.accountFileList.forEach(item => {
                  if(item.useType == 4){
                    item.fileId = res.data.psFileId
                  }
                })
              }else{
                 this.fzEditForm.bankAccountFileId = res.data.imgPath
              }

            }

          } else {
            this.$message.error(res.msg)
          }
        })
      },
      importGXfile(val) {
        let formData = new FormData();
        formData.append('file', val.file);
        fileOnload(formData).then(res => {
          if (res.status == 1) {
            this.tempMan.manFileList.push({
              originalName:val.file.name,
              fileId: res.data.psFileId,
              fileName: res.data.imgName,
              filePath: res.data.imgPath,
              fileType: res.data.imgSuffix,
              useType: val.data.type
            })
            if (val.data.type == 1) {
              this.tempMan.faceImageFileId = res.data.imgPath
            } else {
              this.tempMan.nationalImageFileId = res.data.imgPath
            }
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      saveMan() {
        this.$refs.tempMan.validate(valid => {
          if (valid) {
            if(this.gTitle == '添加'){
              let obj = Object.assign({}, this.tempMan)
              this.manList.push(obj)
            }else{
              let obj = Object.assign({}, this.tempMan)
              this.manList[this.curGxIdx] = obj
            }
            this.gxVisible = false
             console.log(this.manList)
          }
        })
      },

      dellMan(man,idx){
        this.manList.splice(idx,1)
      },
      detailMan(man,idx) {
        this.gTitle = '编辑'
        this.gxVisible = true
        this.gtype1 = []
        this.gtype2 = []
        this.idDate = [man.certEffectDate,man.certExpireDate]
        let obj = Object.assign({}, man)
        this.tempMan =obj
        this.curGxIdx = idx
        this.tempMan.manFileList.forEach(item => {
          let file = {
            name:item.originalName,
            url:item.filePath
          }
          if(item.useType == 1){
            this.gtype1.push(file)
          }else{
            this.gtype2.push(file)
          }
        })

      },
      handelGx() {
        this.gTitle = '添加'
        this.gxVisible = true
        this.idDate = [],
        this.tempMan.certEffectDate = ""
        this.tempMan.certExpireDate = ""
        this.tempMan.certNo = ""
        this.tempMan.certType = 31
        this.tempMan.ctctAddr = ""
        this.tempMan.ctctCell = ""
        this.tempMan.ctctEmail = ""
        this.tempMan.manFileList = []
        this.tempMan.manName = ""
        this.tempMan.manType = "1"



        this.$nextTick(() => {
          this.$refs.tempMan.clearValidate()
          this.$refs.upid1.clearFiles()
          this.$refs.upid2.clearFiles()
        })

      },



      handelSaveRule() {
        this.$refs.fzEditForm.validate(valid => {
          if (valid) {
            if(this.isDatail){
              //修改
              let param = {
                acctBank:this.fzEditForm.acctBank,
                acsMerNo:this.fzEditForm.acsMerNo,
                applyNo:this.fzEditForm.applyNo,
                bankAccountName:this.fzEditForm.bankAccountName,
                bankAccountNo:this.fzEditForm.bankAccountNo,
                bankAccountType:this.fzEditForm.bankAccountType,
                bankCity:this.fzEditForm.bankCity,
                bankCode:this.fzEditForm.bankCode,
                bankCounty:this.fzEditForm.bankCounty,
                bankName:this.fzEditForm.bankName,
                bankNetCode:this.fzEditForm.bankNetCode,
                bankPhone:this.fzEditForm.bankPhone,
                bankProvince:this.fzEditForm.bankProvince,
                divide:this.fzEditForm.divide,
                psNo:this.fzEditForm.psNo,
                receiverType:this.fzEditForm.receiverType,
                ruleAccountFileList:this.fzEditForm.accountFileList,
                ruleId:this.fzEditForm.ruleId,


              }
              eidt_split_rule_account(param).then(res => {
                if(res.code == 200){
                 this.$message({
                   message:"操作成功！已发送验证码，请注意查看手机短信",
                   type: 'success',
                   duration:5000
                 })
                  this.fzVisible = false
                  this.msgVisible = true
                  this.msgForm.verifyCode = ''
                  this.msgForm.acsMerNo = res.data.acsMerNo
                  this.msgForm.applyNo = res.data.applyNo
                  this.msgForm.busType = this.isDatail ? 1:0
                  this.getSplitAccount()
                  //this.getfzDate()
                }else{
                  this.$message.error(res.msg)
                }
              })

            }else{
              //添加
              if(this.fzEditForm.receiverType != 2){
                 if(this.manList.length == 0){
                  this.$message.warning('请点击添加干系人')
                  return
                }
              }
              this.fzEditForm.custManList = this.manList
              this.fzSetloading = true
              add_split_rule_account(this.fzEditForm).then(res => {
                this.fzSetloading = false
                if (res.code == 200) {

                  this.$message({
                    message:"操作成功！已发送验证码，请注意查看手机短信",
                    type: 'success',
                    duration:5000
                  })
                  this.fzVisible = false
                  this.msgVisible = true
                  this.msgForm.verifyCode = ''
                  this.msgForm.acsMerNo = res.info.acsMerNo
                  this.msgForm.applyNo = res.info.applyNo
                  this.msgForm.busType = this.isDatail ? 1:0
                  this.getSplitAccount()

                } else {
                  this.$message.error(res.msg)
                }
              })
            }

          }
        })
      },

      handelAdd() {
        this.title = '添加'
        this.FormVisible = true
      },

      handelFz(row) {

        this.szListVisible = true
        this.currid = row.id
        this.fzEditForm.ruleId = row.id
        this.getSplitAccount()

      },



      getSplitAccount(){
        this.fzloading = true
        get_split_account(this.currid).then(res => {
          this.fzloading = false
          if(res.status == 1){
            this.fzDataList = res.data
          }else{
            this.$message.error(res.msg)
          }

        })
      },


      changeDept() {

      },

      handelAddress(val) {

        this.fzEditForm.bankProvince = val[0]
        this.fzEditForm.bankCity = val[1]
        this.fzEditForm.bankCounty = val[2]

      },


      handelSp(row) {
        this.spVisible = true
        this.spForm.id = row.id
        this.spForm.status = row.status

      },


      changeStatus() {

        this.$refs.spForm.validate(valid => {
          if (valid) {
            approve_rule(this.spForm).then(res => {
              if (res.status == 1) {
                this.$message.success('操作成功!')
                this.getData()
                this.spVisible = false

              } else {
                this.$message.error(res.msg)
              }
            })
          }
        })


      },


      handeRuleSave() {
        this.$refs.editForm.validate(vaild => {
          if (vaild) {
            if (this.title == '添加') {
              this.addRule()
            } else {
              this.upDateRule()
            }
          }
        })
      },
      addRule() {
        addRule(this.editForm).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.FormVisible = false
            this.getData()
          } else {
            this.$message.error(res.msg)
          }
        })
      },

      handelDetail(row) {
        this.FormVisible = true
        this.title = '编辑'
        this.editForm.id = row.id
        this.editForm.ruleName = row.ruleName
        this.editForm.rate = row.rate
        this.editForm.departmentId = row.departmentId
      },
      handelfzDel(row){
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          del_split_account_detail(row.applyNo).then(res => {
            if (res.status == 1) {
              this.$message.success("操作成功!")
              this.getSplitAccount()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      },
      handelDel(row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delRule({
            id: row.id
          }).then(res => {
            if (res.status == 1) {
              this.$message.success("操作成功!")
            } else {
              this.$message.error(res.msg)
            }
          })
        })
      },

      upDateRule() {
        editRule(this.editForm).then(res => {
          if (res.status == 1) {
            this.$message.success('操作成功！')
            this.FormVisible = false
            this.getData()
          } else {
            this.$message.error(res.msg)
          }
        })
      },


      search() {
        this.pageparm.currentPage = 1
        this.formInline.currentPage = 1
        this.showPage = false
        this.getData()
        this.$nextTick(() => {
          this.showPage = true
        })
      },

      //获取集中器信息
      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.treeDate = res.data.menuDepList

              resolve(res.data.terIds)
            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },



      getData() {




        this.loading = true
        get_split_rule_page(this.formInline).then(res => {
            this.loading = false
            if (res.status == 1) {
              this.dataList = res.data.content
              // this.pageparm.currentPage = this.formInline.currentPage
              // this.pageparm.pageSize = this.formInline.pageSize
              // this.pageparm.total = res.data.totalCount
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取数据失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getData()
      },

      zfcallFather(parm){
        this.accountFrom.currentPage = parm.currentPage
        this.accountFrom.pageSize = parm.pageSize

        this.getAccountList()
      },
      getDate(val) {
        this.formInline.startTime = timestampToTime(this.dateData[0]).substring(0, 10)
        this.formInline.endTime = timestampToTime(this.dateData[1]).substring(0, 10)
        this.getData()
      }
    },
  }
</script>

<style scoped>
  .warning{



  }

  .e-ps{
    padding: 0px 4px;
    border-radius: 4px;
    margin: 2px 0;
  }
  .e-ps.warning{
    background-color: #fff6f7;
    border-left: 5px solid #fe6c6f;
  }

  .e-ps.tip{
    border-left: 5px solid #50bfff;
    background-color: #ecf8ff;
  }
  .e-ps p{
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/views/prepayment/bank.vue